import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { ReactNode } from 'react'

type Props = {
    onClick: () => void
    isPrevious?: boolean
    text: string
}

const Icon = ({ children }: { children: ReactNode }) => {
    return (
        <Box
            component={'span'}
            sx={{
                margin: '0 10px',
                border: '1px solid white',
                borderRadius: '50%',
                padding: '7px 9px',
                marginBottom: '0',
                lineHeight: '1',
            }}
        >
            {children}
        </Box>
    )
}
function NextButton({ onClick, text, isPrevious }: Props) {
    return (
        <Button
            onClick={onClick}
            variant="text"
            sx={{
                color: 'white',
                textTransform: 'none',
                fontSize: '1.30em',
                m: {
                    xs: 1,
                    sm: 1,
                    md: 4,
                },
            }}
            startIcon={
                isPrevious && (
                    <Icon>
                        <ArrowBack />
                    </Icon>
                )
            }
            endIcon={
                !isPrevious && (
                    <Icon>
                        <ArrowForward />
                    </Icon>
                )
            }
            type={isPrevious ? 'button' : 'submit'}
        >
            <Typography variant="h5">
                <b>{text}</b>
            </Typography>
        </Button>
    )
}

export default NextButton
